import styled from 'styled-components';

export const Container = styled.button`
  display: block;
  float: right;
  width: 237px;
  height: 40px;
  background-color: var(--primaryColor);
  border: 1px solid var(--primaryColor);
  box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
  border-radius: 5px;
  color: #fff;
  font-size: 1rem;
  transition: all 0.3s;
  max-width: 100%;

  &:hover {
    background-color: transparent;
    color: #181818;
  }
`;
